export class ActionLogQueryInfo{
    operator : string
    startTime : number
    endTime : number
    searchText : string
    ip : string
}